import { render, staticRenderFns } from "./training-video.vue?vue&type=template&id=2c871ab8&scoped=true&"
import script from "./training-video.vue?vue&type=script&lang=js&"
export * from "./training-video.vue?vue&type=script&lang=js&"
import style0 from "./training-video.vue?vue&type=style&index=0&id=2c871ab8&prod&lang=scss&scoped=true&"
import style1 from "./training-video.vue?vue&type=style&index=1&id=2c871ab8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c871ab8",
  null
  
)

export default component.exports